export enum DrawerAction {
  DESTROY = 'DRAWER_DESTROY',
  INSERT = 'DRAWER_INSERT',
  HIDE = 'DRAWER_HIDE',
}

export enum DrawerCustomTemplate {
  DETAILS = 'DETAILS',
}
